import { apiHelper } from '@/utils'

//API endpoints
const AI_APPLICATION = {
  AI_APPLICATION: 'ai-application'
}

export function getAllAIApplications(filter) {
  const requestOptions = {
    params: {}
  }

  requestOptions.params.order = 'DESC'

  if (filter != '' && filter != 'undefined' && filter != null) {
    if (filter.aiStatus) {
      requestOptions.params.aiStatus = filter.aiStatus
    }
    if (filter.applicationType) {
      requestOptions.params.applicationType = filter.applicationType
    }
    if (filter.fromDate) {
      requestOptions.params.fromDate = filter.fromDate
    }
    if (filter.endDate) {
      requestOptions.params.toDate = filter.endDate
    }
    if (filter.nric) {
      requestOptions.params.nric = filter.nric
    }
    if (filter.agentCode) {
      requestOptions.params.name = filter.agentCode
    }
    if (filter.referenceNumber) {
      requestOptions.params.referenceNumber = filter.referenceNumber
    }
    if (filter.address) {
      requestOptions.params.address = filter.address
    }
  }

  return apiHelper().get(`/${AI_APPLICATION.AI_APPLICATION}`, requestOptions)
}

export function createAIApplication(data) {
  const requestOptions = {
    customerName: data.name,
    nric: data.nric,
    phone: data.phone,
    email: data.email,
    addressLine1: data.addressLine1,
    addressLine2: data.addressLine2,
    addressLine3: data.addressLine3,
    city: data.city,
    postcode: data.postcode,
    state: data.state,
    country: data.country,
    applicationDate: data.applicationDate,
    aiStatus: data.aiStatus,
    user: data.user,
    product: data.product,
    tiktokAccount: data.tiktokAccount,
    avatar: data.avatar,
    pc: data.pc,
    referenceNumber: data.referenceNumber,
    remarks: data.remarks,
    serviceStartDate: data.serviceStartDate,
    serviceEndDate: data.serviceEndDate,
    totalPrice: data.totalPrice,
    paymentDate: data.paymentDate,
    duplicatedFrom: data.duplicatedFrom || null
  }

  return apiHelper().post(`/${AI_APPLICATION.AI_APPLICATION}`, requestOptions)
}

export function getAIApplication(id) {
  return apiHelper().get(`/${AI_APPLICATION.AI_APPLICATION}/${id}`)
}

export function editAIApplication(id, data) {
  const requestOptions = {
    customerName: data.name,
    nric: data.nric,
    phone: data.phone,
    email: data.email,
    addressLine1: data.addressLine1,
    addressLine2: data.addressLine2,
    addressLine3: data.addressLine3,
    city: data.city,
    postcode: data.postcode,
    state: data.state,
    country: data.country,
    applicationDate: data.applicationDate,
    aiStatus: data.aiStatus,
    user: data.user,
    product: data.product,
    tiktokAccount: data.tiktokAccount,
    avatar: data.avatar,
    pc: data.pc,
    referenceNumber: data.referenceNumber,
    remarks: data.remarks,
    serviceStartDate: data.serviceStartDate,
    serviceEndDate: data.serviceEndDate,
    totalPrice: data.totalPrice,
    paymentDate: data.paymentDate,
    duplicatedFrom: data.duplicatedFrom || null
  }

  return apiHelper().patch(`/${AI_APPLICATION.AI_APPLICATION}/${id}`, requestOptions)
}

export function editClaimReconcile(id, data) {
  const requestOptions = {
    invoiceNumber: data.invoiceNumber,
    reconcileRemark: data.reconcileRemark,
    reconcileStatus: data.reconcileStatus
  }

  return apiHelper().patch(`/${AI_APPLICATION.AI_APPLICATION}/${id}/reconcile`, requestOptions)
}
